<template>
    <div class="gzdt_children">
      <div v-if="loading">
        <p>{{objectView.name}}</p>
        <div class="line"></div>
        <!-- 相对定位的容器，用于放置相对于pdf-container垂直居中的按钮 -->
        <div class="pdf-container-wrapper" v-if="objectView.fj">
          <!-- 左右两侧的翻页按钮 -->
          <button class="pdf-nav-btn prev-btn" @click="prevPage" :disabled="currentPage <= 1" v-if="pdfDoc">上一页</button>
          <button class="pdf-nav-btn next-btn" @click="nextPage" :disabled="currentPage >= totalPages" v-if="pdfDoc">下一页</button>
          
          <div class="pdf-container">
            <div class="pdf-controls" v-if="pdfDoc">
              <span class="page-info">{{currentPage}} / {{totalPages}}</span>
              <button @click="zoomIn">放大</button>
              <button @click="zoomOut">缩小</button>
              <button @click="resetZoom">重置缩放</button>
              <button @click="readPdf" :class="{ 'reading-active': isReading }">
                {{ isReading ? '停止朗读' : '语音读书' }}
              </button>
              <button @click="pauseReading" v-if="isReading">暂停朗读</button>
              <button @click="resumeReading" v-if="isPaused">恢复朗读</button>
              <!-- <button @click="downloadPdf">下载PDF</button> -->
            </div>
            <div ref="pdfContainer" class="pdf-viewer"></div>
            <div v-if="pdfLoading" class="pdf-loading">正在加载PDF文档...</div>
            <div v-if="pdfError" class="pdf-error">
              <p>{{pdfError}}</p>
              <p><a :href="objectView.fj" target="_blank">点击此处</a>直接查看或下载PDF文件</p>
            </div>
          </div>
        </div>
        <div v-else style="width: 100%; min-height: 10px; text-align: center; padding: 20px;">
          暂无PDF文件可供预览
        </div>
      </div>
    </div>
</template>

<script>
import { httpAction } from '@/api/manage'
import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

// 设置PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

export default {
  name: "pdfView",
  data(){
    return{
      objectView:{},
      id:"",
      loading:false,
      pdfLoading: false,
      pdfError: '',
      pdfDoc: null,
      pdfRenderTask: null,
      currentPage: 1,
      totalPages: 0,
      scale: 1.0,
      // 语音朗读相关状态
      isReading: false,
      isPaused: false, // 自定义暂停状态标志
      isStopping: false, // 是否是用户主动停止朗读的标志
      speechSynthesis: window.speechSynthesis,
      utterance: null,
      readingQueue: [],
      currentUtterance: null
    }
  },
  created(){
    this.id = this.$route.query.id || ''
    this.getView()
  },
  watch: {
    'objectView.fj': function(newVal) {
      if (newVal) {
        this.loadPdf(newVal)
      }
    }
  },
  beforeDestroy() {
    // 清理PDF资源
    if (this.pdfRenderTask) {
      this.pdfRenderTask.cancel()
    }
    if (this.pdfDoc) {
      this.pdfDoc.destroy()
    }
    // 清理语音朗读资源
    if (this.speechSynthesis) {
      this.speechSynthesis.cancel()
    }
    this.utterance = null
    this.currentUtterance = null
    this.readingQueue = []
    this.isReading = false
    this.isPaused = false
  },
  methods:{
    getView(){
      httpAction("/zxwz/zxwztsgl/query/by/id?id="+this.id,{},'get').then((res)=>{
        if(res.success){
          this.loading = true
          this.objectView = res.result;
        }else{
          this.$message.warning(res.message);
        }
      })
    },
    
    async loadPdf(pdfUrl) {
      this.pdfLoading = true
      this.pdfError = ''
      this.currentPage = 1
      this.totalPages = 0
      
      try {
        // 确保DOM已经渲染，pdfContainer引用已经存在
        await this.$nextTick()
        const container = this.$refs.pdfContainer
        
        if (!container) {
          throw new Error('PDF容器元素未找到')
        }
        
        container.innerHTML = ''
        
        // 加载PDF文档
        const loadingTask = pdfjsLib.getDocument({
          url: pdfUrl,
          cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@latest/cmaps/',
          cMapPacked: true
        })
        
        this.pdfDoc = await loadingTask.promise
        this.totalPages = this.pdfDoc.numPages
        
        // 渲染第一页
        await this.renderPage(this.currentPage)
        
      } catch (error) {
        console.error('PDF加载或渲染错误:', error)
        this.pdfError = `PDF加载失败: ${error.message || '未知错误'}`
      } finally {
        this.pdfLoading = false
      }
    },
    
    async renderPage(pageNum) {
      try {
        const container = this.$refs.pdfContainer
        if (!container || !this.pdfDoc) return
        
        // 获取PDF页面
        const page = await this.pdfDoc.getPage(pageNum)
        
        // 设置缩放比例
        const viewport = page.getViewport({ scale: this.scale })
        
        // 创建canvas元素
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        
        // 设置canvas尺寸
        canvas.height = viewport.height
        canvas.width = viewport.width
        
        // 清除容器内容并添加canvas
        container.innerHTML = ''
        container.appendChild(canvas)
        
        // 渲染PDF页面到canvas
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        }
        
        // 取消之前的渲染任务
        if (this.pdfRenderTask) {
          this.pdfRenderTask.cancel()
        }
        
        // 开始渲染
        this.pdfRenderTask = page.render(renderContext)
        await this.pdfRenderTask.promise
        
        // 更新当前页码
        this.currentPage = pageNum
        
      } catch (error) {
        console.error('PDF页面渲染错误:', error)
        this.pdfError = `页面渲染失败: ${error.message || '未知错误'}`
      }
    },
    
    prevPage() {
      if (this.currentPage <= 1) return
      this.renderPage(this.currentPage - 1)
    },
    
    nextPage() {
      if (this.currentPage >= this.totalPages) return
      this.renderPage(this.currentPage + 1)
    },
    
    zoomIn() {
      this.scale += 0.2
      this.renderPage(this.currentPage)
    },
    
    zoomOut() {
      if (this.scale > 0.4) {
        this.scale -= 0.2
        this.renderPage(this.currentPage)
      }
    },
    
    resetZoom() {
      this.scale = 1.0
      this.renderPage(this.currentPage)
    },
    
    downloadPdf() {
      if (!this.objectView.fj) return
      
      // 创建下载链接
      const link = document.createElement('a')
      link.href = this.objectView.fj
      link.download = this.objectView.name || 'document.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    
    // 语音朗读PDF内容
    async readPdf() {
      // 检查是否正在朗读，如果是则停止
      if (this.isReading) {
        this.stopReading()
        return
      }
      
      // 检查浏览器是否支持Web Speech API
      if (!('speechSynthesis' in window)) {
        this.$message.warning('您的浏览器不支持语音朗读功能，请使用Chrome、Edge等现代浏览器')
        return
      }
      
      try {
        this.isReading = true
        this.$message.info('开始朗读第' + this.currentPage + '页...')
        
        // 获取当前页的文本内容
        const pageText = await this.extractTextFromPage(this.currentPage)
        
        if (!pageText.trim()) {
          this.$message.warning('当前页面没有可朗读的文本内容')
          this.isReading = false
          return
        }
        
        // 开始朗读文本
        this.speakText(pageText)
        
      } catch (error) {
        console.error('语音朗读错误:', error)
        this.$message.error('语音朗读失败: ' + (error.message || '未知错误'))
        this.isReading = false
      }
    },
    
    // 从PDF页面提取文本
    async extractTextFromPage(pageNum) {
      if (!this.pdfDoc) return ''
      
      try {
        const page = await this.pdfDoc.getPage(pageNum)
        const content = await page.getTextContent()
        
        // 提取并连接所有文本
        const textItems = content.items.map(item => item.str)
        return textItems.join(' ').replace(/\s+/g, ' ').trim()
      } catch (error) {
        console.error('提取文本失败:', error)
        throw new Error('无法提取PDF文本内容')
      }
    },
    
    // 使用Web Speech API朗读文本
    speakText(text) {
      // 停止之前可能的朗读
      this.speechSynthesis.cancel()
      
      // 创建语音合成实例
      this.utterance = new SpeechSynthesisUtterance(text)
      
      // 设置语音参数
      this.utterance.lang = 'zh-CN' // 设置为中文
      this.utterance.rate = 1.0 // 语速（0.1-10之间）
      this.utterance.pitch = 1.0 // 音调（0-2之间）
      this.utterance.volume = 1.0 // 音量（0-1之间）
      
      // 设置事件监听器
      this.utterance.onstart = () => {
        console.log('开始朗读')
      }
      
      this.utterance.onend = async () => {
        console.log('朗读结束')
        
        // 清除暂停状态
        this.isPaused = false
        
        // 检查是否有下一页，如果有则自动翻页继续朗读
        if (this.currentPage < this.totalPages && this.isReading) {
          // 切换到下一页
          this.currentPage++
          await this.renderPage(this.currentPage)
          this.$message.info('开始朗读第' + this.currentPage + '页...')
          
          // 提取并朗读下一页的文本
          try {
            const nextPageText = await this.extractTextFromPage(this.currentPage)
            if (nextPageText.trim()) {
              this.speakText(nextPageText)
            } else {
              // 如果下一页没有文本，继续下一页
              this.utterance.onend()
            }
          } catch (error) {
            console.error('自动翻页朗读失败:', error)
            this.isReading = false
            this.isPaused = false
            this.$message.error('自动翻页朗读失败')
          }
        } else {
          // 所有页面朗读完毕
          this.isReading = false
          this.$message.success('朗读完成')
        }
      }
      
      this.utterance.onerror = (event) => {
        console.error('朗读错误:', event.error)
        this.isReading = false
        // 只有在不是用户主动停止的情况下才显示错误提示
        if (!this.isStopping) {
          //this.$message.error('朗读过程中发生错误')
        }
        // 重置停止标志
        this.isStopping = false
      }
      
      // 开始朗读
      this.speechSynthesis.speak(this.utterance)
      this.currentUtterance = this.utterance
    },
    
    // 停止朗读
    stopReading() {
      if (this.speechSynthesis && (this.isReading || this.isPaused)) {
        // 设置停止标志，避免触发错误提示
        this.isStopping = true
        
        this.speechSynthesis.cancel()
        this.isReading = false
        this.isPaused = false // 停止时同时清除暂停状态
        this.$message.info('已停止朗读')
      }
    },
    
    // 暂停朗读
    pauseReading() {
      if (this.speechSynthesis && this.isReading) {
        this.speechSynthesis.pause()
        this.isReading = false // 暂停时设置isReading为false
        this.isPaused = true // 设置自定义暂停标志为true
        this.$message.info('已暂停朗读')
      }
    },
    
    // 恢复朗读
    resumeReading() {
      if (this.speechSynthesis && this.isPaused) {
        this.isReading = true // 先设置朗读状态
        this.isPaused = false // 清除暂停标志
        this.speechSynthesis.resume()
        this.$message.info('已恢复朗读')
      }
    }
  }
}
</script>

<style scoped lang="less">
.gzdt_children{
    width: 100%;
    height: auto;
    position: relative;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    

  p{
    width: 100%;
    font-family: PingFangSC-SNaNpxibold;
    font-weight: 600;
    margin: 0 auto;
    text-align: center;
    font-family: PingFangSC-SNaNpxibold;
    font-weight: 600;
    font-size: 36px;
    color: #3779C7;
    letter-spacing: 0;

    a{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      letter-spacing: 0;
      position: absolute;
      right: 0;
    }
    padding-bottom: 15px;
  }

  a{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    letter-spacing: 0;
    margin: 0 auto;
  }

}

.jgx0{
    margin-bottom: 20px;
    position: relative;
    
}

.jgx0:after{
    content: "";
    position: absolute;
    width: 105%;
    height: 1px;
    left: 50%;
    transform: translate(-50%,0);
    background: #EBEBEB;
    bottom: -10px;
}

button{
    cursor: pointer;
}

.xzxg{
    width: 32px;
    height: 32px;
    background: #2C75DF;
    border: 1px solid #2966AE;
    border-radius: 3px;
    color: #fff;
    
}   
.wxzxg{
    width: 32px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D3D3D3;
    border-radius: 3px;
}


.nextPage{
    width: 70px;
    height: 32px;
    border: 1px solid #BFBFBF;
    border-radius: 3px;
}

.clickTrue{
    background: #fff !important;
}

.clickFalse{
    background: #E1E1E1;
}

.clickTrue:hover,.wxzxg:hover{ 
    background: #2c75df90 !important;
    color: #fff;
}

.pagePar{
    width: 80%;
    display: flex;
    align-items: center;
}

.pageLeft{
    margin: auto;
}
.pageCenter{
    margin: auto;
    display: flex;
    justify-content: center;
    button{
        margin: auto 3px;
    }
}
.pageRight{
    margin: auto;
}

.sdtz{
    width: 32px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D3D3D3;
    border-radius: 3px;
    padding: 0 5px;
    outline: none;
}

.line{
  height: 1px;
  width: 100%;
  background: #EBEBEB;
  margin: 30px 0;
}

.pdf-container-wrapper {
  position: relative;
  width: 100%;
  margin-top: 20px;
}

.pdf-container {
  width: 100%;
  height: 80vh;
  position: relative;
  overflow: auto;
  border: 1px solid #EBEBEB;
  border-radius: 4px;
}

.pdf-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: wrap;
}

/* PDF导航按钮样式 */
.pdf-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #ddd;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.pdf-nav-btn:hover:not(:disabled) {
  background: #2C75DF;
  color: white;
  border-color: #2C75DF;
  box-shadow: 0 4px 12px rgba(44, 117, 223, 0.3);
}

.pdf-nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

.page-info {
  font-weight: bold;
  margin: 0 10px;
}

.pdf-controls button {
  padding: 8px 16px;
  background-color: #2C75DF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.pdf-controls button:hover:not(:disabled) {
  background-color: #1e5aa8;
}

.pdf-controls button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pdf-controls button.reading-active {
  background-color: #e74c3c;
}

.pdf-controls button.reading-active:hover {
  background-color: #c0392b;
}

.pdf-controls span {
  padding: 0 10px;
  font-weight: 500;
  color: #333;
}

.pdf-viewer {
  width: 100%;
  min-height: calc(80vh - 80px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
}

.pdf-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #e74c3c;
  padding: 20px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.pdf-error a {
  color: #2C75DF;
  text-decoration: underline;
}

.pdf-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
}

footer{
  margin: 50px 0 10px 0;
  p{
    font-family: PingFangSC-Medium !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    color: #333333 !important;
    letter-spacing: 0 !important;
    text-align: left  !important;
    line-height: 30px;
    cursor: pointer;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}


.slt_par{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img{
    max-height: 400px;
    max-width: 600px;
    margin: 10px auto;
  }
}

.ccsl{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  line-height: 50px;
  color: #34c4ed;
  font-size: 16px;
}


</style>